
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { defineComponent } from 'vue';

  export interface BaseStepProperties {
    n: number;
    title: string;
    collapsed: boolean;
    active: boolean;
    showEditButton: boolean;
  }

  export const BASE_STEP_PROPS = ['n', 'title', 'collapsed', 'active', 'showEditButton'];

  export default defineComponent<BaseStepProperties>({
    props: BASE_STEP_PROPS,

    setup(props) {
      const store = useIntegrationDetailsStore();
      const setStep = () => {
        store.setStep(props.n - 1);
      };

      return {
        setStep,
      };
    },
  });
